export default "__VITE_ASSET__BfQptQLL__"